import Vue from 'vue'
import Router from 'vue-router'
import Guide from '@/views/guide/index.vue'
import Login from '@/views/login/index.vue'
import reg from '@/views/reg/index.vue'
import checked_info from '@/views/checked_info/index.vue'
import person_center from '@/views/person_center/index1.vue'
import person_list from '@/views/person_list/index1.vue'
import update_pwd from '@/views/update_pwd/index.vue'
import editPet from '@/views/edit_info/index.vue'
import editProfile from '@/views/edit_info/profile.vue'
import forget_pwd from '@/views/forget_pwd/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Guide',
      component: Guide
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/reg',
      name: 'reg',
      component: reg
    }, {
      path: '/checked_info',
      name: 'checked_info',
      component: checked_info
    }, {
      path: '/checked_info/:petId',
      name: 'checked_info1',
      component: checked_info
    }, {
      path: '/person_center',
      name: 'person_center',
      component: person_center
    }, {
      path: '/update_pwd',
      name: 'update_pwd',
      component: update_pwd
    }, {
      path: '/person_list',
      name: 'person_list',
      component: person_list
    },
    // 修改宠物信息页面
    {
      path: '/edit_info/pet/:petId',
      name: 'edit-pet',
      component: editPet
    },
    // 修改个人信息页面
    {
      path: '/edit_info/profile',
      name: 'edit-profile',
      component: editProfile
    }, {
      path: '/forget_pwd',
      name: 'forget_pwd',
      component: forget_pwd
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js